import MuiToolbar from '@mui/material/Toolbar';
import type { MaterialTableProps } from 'material-table';
import * as React from 'react';
import styled from 'styled-components';
import type { TableData } from '../../DataTable';

const StyledToolbar = styled(MuiToolbar)`
  padding: ${(p) => p.theme.spacing(2)};
  padding-bottom: ${(p) => p.theme.spacing(1)};

  ${(p) => p.theme.breakpoints.down('md')} {
    flex-flow: nowrap column;
  }
`;

const StyledSearch = styled('div')``;

const StyledActions = styled('div')`
  margin-left: auto;
  color: ${(p) => p.theme.palette.text.secondary};

  ${(p) => p.theme.breakpoints.down('md')} {
    margin-top: ${(p) => p.theme.spacing(1)};
    margin-left: 0;
  }

  > * {
    margin-left: ${(p) => p.theme.spacing(0.5)};
  }
`;

export interface ToolbarProps {
  search?: (props: any) => React.ReactNode;
  actions?: (props: any) => React.ReactNode;
  tableProps: MaterialTableProps<TableData>;
}

export const Toolbar: React.FC<ToolbarProps> = ({ search, actions, tableProps }) => {
  if (!search && !actions) {
    return null;
  }

  return (
    <StyledToolbar variant="dense">
      {search && <StyledSearch>{search(tableProps)}</StyledSearch>}
      {actions && <StyledActions>{actions(tableProps)}</StyledActions>}
    </StyledToolbar>
  );
};
